import { IncomingMessage, ServerResponse } from 'http'
import { GenericException } from '@reward-platform/shared-api/exceptions/GenericException'
import { createServerLoggerMeta } from '@reward-platform/logger/utils'
import logger from '@reward-platform/logger/server/next'
import { getUserId } from '@reward-platform/auth0-b2c'
import { LOG_SOURCE_LABELS } from '@reward-platform/shared-api/exceptions/ErrorCodes'
import 'winston'
import 'chalk'

export async function logRequestToDatadog(
  req: IncomingMessage,
  res: ServerResponse,
  error?: GenericException,
  additionalData = {}
) {
  const searchEngine = req.headers['x-search-engine']
  const userIdFromSession = await getUserId(req, res)
  const userId = userIdFromSession ?? 'unauthenticated_user'
  const loggerRequestContext = createServerLoggerMeta(req, res, {
    userId,
    searchEngine,
  })

  if (error) {
    const getRequestMessage = (msg?: string) =>
      `${msg} on HTTP ${req.method} ${loggerRequestContext.meta.req.path} [OpCo: ${loggerRequestContext.meta.opCo}, CorrelationId: ${loggerRequestContext.meta.correlationId}]`
    const { message, ...loggerErrorContext } = error.formatErrorForLogs('next')

    loggerRequestContext.http = {
      ...loggerRequestContext.http,
      status_code: loggerErrorContext.error.httpStatus,
    }

    // Logs to datadog logging or to console if non production
    // Logs to dd error tracking, can check error here https://app.datadoghq.eu/apm/error-tracking
    logger.error(getRequestMessage(message), {
      ...loggerRequestContext,
      ...loggerErrorContext,
      additionalData,
    })
  } else {
    const loggerMsg = `[${LOG_SOURCE_LABELS.next} Response] HTTP ${req.method} ${loggerRequestContext.meta.req.path} [OpCo: ${loggerRequestContext.meta.opCo}, CorrelationId: ${loggerRequestContext.meta.correlationId}]`

    if (res.statusCode >= 500) {
      logger.error(loggerMsg, {
        ...loggerRequestContext,
        additionalData,
      })
    } else if (res.statusCode >= 400 && res.statusCode < 500) {
      logger.warn(loggerMsg, {
        ...loggerRequestContext,
        additionalData,
      })
    } else {
      logger.info(loggerMsg, {
        ...loggerRequestContext,
        additionalData,
      })
    }
  }
}

// logger: winston.Logger
export { logger }
